import React from 'react';

export function SurveyResultsTab() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-white mb-2">Survey Results</h2>
        <p className="text-gray-300">
          View comprehensive survey data and insights from our community engagement activities.
        </p>
      </div>

      {/* Embedded Survey Results */}
      <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-lg overflow-hidden">
        <div className="p-4 border-b border-gray-700">
          <h3 className="text-xl font-semibold text-white">Community Survey Dashboard</h3>
          <p className="text-sm text-gray-400 mt-1">
            Interactive data visualization powered by Google Looker Studio
          </p>
        </div>
        
        <div className="relative w-full" style={{ paddingBottom: '73.83%' }}>
          <iframe 
            src="https://lookerstudio.google.com/embed/reporting/ea20a220-1bfa-4af0-8897-0ffe187a35db/page/ILTdF" 
            frameBorder="0" 
            className="absolute top-0 left-0 w-full h-full"
            style={{ border: 0 }} 
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          />
        </div>
      </div>

      {/* Additional Information */}
      <div className="bg-blue-900/20 border border-blue-700/50 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <div>
            <h4 className="font-semibold text-blue-300 mb-1">Interactive Dashboard</h4>
            <p className="text-sm text-gray-300">
              This dashboard is interactive - you can filter data, view different time periods, and explore various metrics. 
              Click on different sections to drill down into the data.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
